import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { urls } from "../../../urls";
import { useApiError } from "../../../common/errors/useApiError";
import { useAppDispatch, useAppSelector } from "../../../common/redux/hooks";
import { loadContractThunk } from "../../../common/redux/thunks/contract/load-contract-thunk";
import { EditContractForm } from "./EditContractForm";

export const EditContract = ({ embedded = false }: { embedded?: boolean }) => {
  const { contractId } = useParams();
  const dispatch = useAppDispatch();
  const contractState = useAppSelector((state) => state.contract.state);
  const { t } = useTranslation();
  const { showNoAccess } = useApiError();

  useEffect(() => {
    if (!contractId) return;
    dispatch(loadContractThunk({ contractId }));
  }, [contractId, dispatch]);

  if (!contractId) {
    return <div>{t("404 not found")}</div>;
  }

  if (contractState?.id !== contractId) {
    return <div>{t("Loading")}...</div>;
  }

  if (!contractState.contract.canEditEverything) {
    return showNoAccess({
      message: t("You can view this contract, but you don't have permission to edit it."),
      destination: { href: urls.v2.contracts.view.go(contractId), label: t("Open the contract") },
    });
  }

  return <EditContractForm embedded={embedded} />;
};

